/**
 * 接口服务统一入口
 * Models 层仅通过此文件调用接口
 */
import { categoryService } from './categoryService';
import { regionService } from './regionService';
import { businessService } from './businessService';
import { thematicRouteService } from './thematicRouteService';

export const services = {
  category: categoryService,
  region: regionService,
  business: businessService,
  thematicRoute: thematicRouteService 
};